import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface DifficultyLinkProps {
	difficulty: number
}

export function DifficultyLink(props: DifficultyLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('difficulties', `${props.difficulty}`)
		}}>
			Difficulty {props.difficulty}
		</a>
	)
}
